// extracted by mini-css-extract-plugin
export default {"Container":"ErrorPopper_Container__aukyq","TooltipContainer":"ErrorPopper_TooltipContainer__nXQNW","TooltipArrow":"ErrorPopper_TooltipArrow__OvbjK"};